<template>
  <div class="now-marker" :style="{top: top + 'px'}"></div>
</template>

<script>
  import moment from 'moment'
  export default {
    props: {
      start: {
        default: 6
      },
      slotHeight: {
        default: 40
      }
    },
    computed: {
      top () {
        return this.eventTop()
      }
    },
    methods: {
      eventTop () {
        let calStartTime = moment().hour(this.start).minutes('0')
        let eventStartTime = moment()
        let duration = moment(eventStartTime).diff(calStartTime)
        return ((this.slotHeight * 2) / 60) * moment.duration(duration).asMinutes()
      }
    }
  }
</script>

<style scoped>
  .now-marker {
    position: absolute;
    left: 0;
    right: 0;
    height: 2px;
    z-index: 5;
    background-color: #fa565a;
    pointer-events: none;
  }

  .now-marker:before {
    position: absolute;
    content: '';
    top: 0;
    left: 0;
    border-radius: 50%;
    width: 7px;
    height: 7px;
    margin-left: -4px;
    margin-top: -3px;
    background-color: #fa565a;
  }
</style>



// WEBPACK FOOTER //
// NowIndicator.vue?7438d6a4